<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.75 7h-3.5m7 0A5.25 5.25 0 1 1 1.749 7 5.25 5.25 0 0 1 12.25 7z" stroke-width="1.167" stroke-linecap="round" stroke-linejoin="round" style="stroke: var(--{{variableName}});"/>
</svg>
